export default __webpack_public_path__ + "static/media/natan-goshen_shnei-yeladim.f48d45e3.mp3";